import { LogoutRedirect } from '../../component/auth/account/logout-redirect'
import { FunctionComponent } from 'react'

export const LogoutScreen: FunctionComponent = () => <LogoutRedirect />
